/**
 * @module websocket.event.handlers.airports.airport-deleted
 */
import { store } from '../../../../state/store'
import { setAirportListUpdated } from '../../../../state/websocket.slice'

export default function handleAirportDeleted(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleAirportDeleted', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setAirportListUpdated(data))
  }
} 